<!--
2021-07-06 C007 增加withdraw实名认证相关逻辑
-->
<template>
  <div class="withdrawSetupPage">
    <img class="close" @click="close" src="../../assets/images/WithdrawalSuccessful/close.png" alt="">
    <div class="balanceTitle">
      <div class="title">₹{{ withdrawAmount }}</div>
      <div class="tip">{{ $t('lang.WithdrawalSuccessful.withdrawFee') }}:{{ withdrawFee }}</div>
    </div>
    <div class="formBox">
      <div class="titleBox">
        <div class="title">{{ $t('lang.WithdrawalSuccessful.bankAccount') }}</div>
        <div v-if="!accountInfo[accountInfo.length-1].Id" @click="goCreateAccount()" class="createAccount">
          {{ $t('lang.WithdrawalSuccessful.createAccount') }}
        </div>
      </div>
      <div class="accountList">
        <div class="listBox">
          <div class="nodata"
               v-if="accountInfo[0].Id === null && accountInfo[1].Id === null && accountInfo[2].Id === null">
            <span @click="goCreateAccount()">{{ $t('lang.WithdrawalSuccessful.createAccount') }}</span>
          </div>
          <div v-if="it.Id" v-for="(it,index) in accountInfo" :key="it.Id"
               @click="chooseCard($store.state.bankList[index].Id)"
               :class="($store.state.bankList[index] && $store.state.bankList[index].IsLastUsed)?'accountItemChecked':'accountItem'">
            <div class="itemBox" @click="goCreateAccount (it)">
              <div class="row1">
                <img src="../../assets/images/WithdrawalSuccessful/wallet.png" alt="" class="AccountIcon">
                <div class="AccountName">{{ it.AccountName }}
                  <div class="BankMessage" v-if="it.BankCardVerifyStatus === -10">{{ it.BankMessage }}</div>
                </div>
              </div>
              <div class="row2">
                <div class="accountNumber">{{
                    $t('lang.WithdrawalSuccessful.accountNumber')
                  }}:{{ it.AccountNumber }}
                </div>
              </div>
            </div>
            <div class="edit" v-if="it.BankCardVerifyStatus === -10" @click="goCreateAccount(it)">
              <img v-if="$store.state.locale==='IN'" src="../../assets/images/createBankAccount/edit-hi.svg" alt="">
              <img v-else src="../../assets/images/createBankAccount/edit.svg" alt="">
            </div>
            <div v-else class="checked">
              <div class="node"></div>
            </div>
          </div>
        </div>

        <div class="tip">
          {{ $t('lang.WithdrawalSuccessful.largeWithdrawalsLonger') }}
        </div>
        <div class="delayedBox">
          <div class="head">
            <div class="tipText">{{ $t('lang.WithdrawalSuccessful.ifDelayed') }}</div>
            <div class="deatil" @click="openDeatilShow">{{ $t('lang.WithdrawalSuccessful.detail') }}</div>
          </div>
          <div class="deepBox">
            <div class="line"></div>
            <div class="nodeBox">
              <div class="node"></div>
              <div class="node" v-if="configData.ConfigList[0]">{{ configData.ConfigList[0].Time }}h</div>
              <div class="node" v-if="configData.ConfigList[1]">{{ configData.ConfigList[1].Time }}h</div>
            </div>
            <div class="textBox">
              <div class="text1 text">Start</div>
              <div class="text2 text" v-if="configData.ConfigList[0]"><span v-if="configData.ConfigList[0].IsRefund">Refund+</span>₹{{
                  getcompensateNums(configData.ConfigList[0].Rate)
                }}
              </div>
              <div class="text3 text" v-if="configData.ConfigList[1]"><span v-if="configData.ConfigList[1].IsRefund">Refund+</span>₹{{
                  getcompensateNums(configData.ConfigList[1].Rate)
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="tip">
          <div style="width: 94%">{{ $t('lang.WithdrawalSuccessful.compensationAmountBasedActual') }}</div>
        </div>
        <div @click="handleWithdraw" class="submit">{{ $t('lang.WithdrawalSuccessful.submit') }}</div>
      </div>

    </div>
    <Popup
      v-model='showPopup'
      position='bottom'>
      <Picker
        :slots="bankListSlots"
        :showToolbar="true"
        value-key="name"
        @change="onValueChange">
        <span @click="showPopup = false">Done</span>
      </Picker>
    </Popup>
  </div>
</template>

<script>
import {Popup, Picker, Toast} from 'mint-ui'
import TopBack from '../TopBack/index'
import back from '@/assets/images/withdrawSetup/back.svg'
import frontSide from '@/assets/images/common/frontSide.svg'
import backSide from '@/assets/images/common/backSide.svg'
import withCard from '@/assets/images/common/withCard.svg'
import wallet from '@/assets/images/withdrawSetup/wallet.svg'
import choose1 from '@/assets/images/withdrawSetup/choose1.svg'
import choose2 from '@/assets/images/withdrawSetup/choose2.svg'
import config from '../../../static/config/config'
import request from '@/service'
import {mapMutations} from 'vuex'
import {InternationBankList, InternationIFSCReg, InternationAccountNumberReg, InternationIDCardReg} from '@/constant'

export default {
  name: 'WithdrawSetup',
  props: ['setupType', 'handelBack', 'parentChoose', 'tabList', 'selectTab', 'topTitle', 'withdrawAmount', 'withdrawFee'],
  watch: {
    '$store.state.locale': function () {
      if (this.setupType === 'account') {
        this.title = this.$t('lang.account.withdrawSetup.textYourBank')
        this.accountDict = {
          AccountName: this.$t('lang.account.accountName'),
          AccountNumber: this.$t('lang.account.accountNo'),
          BankCode: this.$t('lang.account.IFSC')
        }
      }
    }
  },
  data () {
    return {
      back,
      frontSide,
      backSide,
      wallet,
      choose1,
      choose2,
      withCard,
      checked: null,
      title: '',
      idSetup: 'info',
      documentList: [
        {
          key: 'frontSide',
          label: this.$t('lang.account.withdrawSetup.textFrontSide'),
          src: frontSide,
          fileServer: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.FrontSideImage : null,
          isUploading: false
        },
        {
          key: 'backSide',
          label: this.$t('lang.account.withdrawSetup.textBackSide'),
          src: backSide,
          fileServer: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.BackSideImage : null,
          isUploading: false
        },
        {
          key: 'withCard',
          label: this.$t('lang.account.withdrawSetup.textPhoto'),
          src: withCard,
          fileServer: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.PhotoWithCardImage : null,
          isUploading: false
        }
      ],
      personalInfo: {
        fullName: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.FullName : null,
        cardNum: this.$store.state.verifyInfo ? this.$store.state.verifyInfo.AadhaarCardNumber : null,
        Birthday: '',
        mobile: ''
      },
      personalDict: {
        fullName: this.$t('lang.account.withdrawSetup.textFullName'),
        cardNum: this.$t('lang.account.withdrawSetup.textCardNumber'),
        Birthday: this.$t('lang.account.withdrawSetup.textBirthday'),
        mobile: this.$t('lang.account.withdrawSetup.textMobileNumber')
      },
      accountInfo: [{
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null,
        BankCardVerifyStatus: null,
        BankMessage: null
      }, {
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null,
        BankCardVerifyStatus: null,
        BankMessage: null
      }, {
        Id: null,
        AccountName: null,
        AccountNumber: null,
        BankCode: null,
        BankCardVerifyStatus: null,
        BankMessage: null
      }],
      accountDict: {
        AccountName: this.$t('lang.account.accountName'),
        AccountNumber: this.$t('lang.account.accountNo'),
        BankCode: this.$t('lang.account.IFSC')
      },
      downloadLnk: config.baseURL + 'mobileapp/pge-' + (localStorage.getItem('cid') || 'app') + '-' + config.apkVersion + '.apk' + `?v=${Date.now()}`,
      IFSCReg: RegExp(/^[A-Za-z]{4}[0]\w{6}$/),
      AccountNameReg: RegExp(/^[a-zA-Z\s]+$/),
      AccountNumberReg: RegExp(/^\d{8,18}$/),
      AadhaarReg: RegExp(/^\d{12}$/),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      showPopup: false,
      activeCardId: -1,
      configData: {
        ConfigList: [],
        DetailEN: '',
        DetailIN: ''
      },
      bankListSlots: [
        {
          flex: 1,
          values: [],
          textAlign: 'center'
        }
      ],
      InternationBankList,
      InternationIFSCReg,
      InternationAccountNumberReg,
      InternationIDCardReg
    }
  },
  mounted () {
    this.getWithdrawConfig()
    switch (this.setupType) {
      case 'id':
        this.title = 'Your ID'
        this.AadhaarReg = this.InternationIDCardReg.getReg(this.$store.state.internation)
        request('post', '/innovation/account/getuserinfo', {
          userId: this.userInfo.UserId,
          isEditPage: false
        }).then(res => {
          if (res.CountryCode && res.Mobile) {
            this.personalInfo.mobile = '+' + res.CountryCode + ' ' + res.Mobile
          }
          if (res.Birthday) {
            this.personalInfo.Birthday = res.Birthday
          }
        })
        break
      case 'account':
        this.title = this.$t('lang.account.withdrawSetup.textYourBank')
        // 2022-02-17 CHP 根据国家版本设置相关信息
        this.bankListSlots[0].values = this.InternationBankList.getBankList(this.$store.state.internation)
        this.IFSCReg = this.InternationIFSCReg.getReg(this.$store.state.internation)
        this.AccountNumberReg = this.InternationAccountNumberReg.getReg(this.$store.state.internation)
        // bankList 赋值
        if (this.$store.state.bankList && this.$store.state.bankList.length > 0 && this.$store.state.bankList.length < 4) {
          this.$store.state.bankList.forEach((item, index) => {
            // 第一次加载记录上次使用的卡
            if (item.IsLastUsed) {
              this.activeCardId = item.Id
            }
            if (item.Id) {
              this.accountInfo[index].Id = item.Id
            }
            this.accountInfo[index].AccountName = item.AccountName
            this.accountInfo[index].AccountNumber = item.AccountNumber
            this.accountInfo[index].BankCode = item.BankCode
            this.accountInfo[index].BankCardVerifyStatus = item.BankCardVerifyStatus
            this.accountInfo[index].BankMessage = item.BankMessage
          })
          if (this.activeCardId === -1 && this.$store.state.bankList && this.$store.state.bankList.length > 0) {
            this.activeCardId = this.$store.state.bankList[0].Id
          }
          this.chooseCard(this.activeCardId)
        }
        break
    }
  },
  components: {
    TopBack,
    Popup,
    Picker
  },
  methods: {
    ...mapMutations({
      setUserVerifyInfo: 'setUserVerifyInfo',
      setUserBankList: 'setUserBankList'
    }),
    close () {
      this.$emit('close')
    },
    getcompensateNums (rate) {
      return Math.round((this.withdrawAmount - this.withdrawFee) * rate)
    },
    getWithdrawConfig () {
      request('get', 'innovation/payments/get/withdraw/delay/config').then(res => {
        console.log(res)
        this.configData = res
      })
    },
    openDeatilShow () {
      this.$emit('openDeatilShow', {DetailEN: this.configData.DetailEN, DetailIN: this.configData.DetailIN})
    },
    handleWithdraw () {
      this.$emit('doWithdraw')
    },
    goCreateAccount (it) {
      if (!it) {
        this.$router.push('/createBankAccount')
      } else if (it.BankCardVerifyStatus === -10) {
        this.$router.push({
          path: '/createBankAccount',
          query: {
            accountInfo: it
          }
        })
      }
    },
    chooseCard (id) {
      let bankList = this.$store.state.bankList
      bankList.forEach((e) => {
        if (e.Id === id) {
          e.IsLastUsed = true
        } else {
          e.IsLastUsed = false
        }
      })
      this.setUserBankList(bankList)
      this.parentChoose(id)
    },
    toUpperCase (event, key) {
      if (key === 'IFSC') {
        event.target.value = event.target.value.toUpperCase()
      }
    },
    upload (key) {
      if (!this.$store.state.verifyInfo ||
        (this.$store.state.verifyInfo && this.$store.state.verifyInfo.IDVerfiyStatus <= 0)) {
        this.$refs[key][0].click()
      }
    },
    uploadFile (key) {
      if (this.$refs[key][0].files.length > 0) {
        let index = 0
        switch (key) {
          case 'frontSide':
            index = 0
            break
          case 'backSide':
            index = 1
            break
          case 'withCard':
            index = 2
            break
        }
        this.documentList[index].isUploading = true
        this.documentList[index].fileServer = null

        let formData = new FormData()
        formData.append('userId', this.userInfo.UserId)
        formData.append('documentType', key)
        formData.append('file', this.$refs[key][0].files[0])
        request('post',
          '/innovation/account/uploadpersonaldocument',
          formData, true).then(res => {
          Toast(res.Message)
          if (res.Code > 0) {
            this.documentList[index].fileServer = res.S3FileURL
            this.setUserVerifyInfo(res.UserVerifyInfo)
          }

          this.documentList[index].isUploading = false
        }).catch(err => {
          console.log(err)
          this.documentList[index].isUploading = false
        })
      }
    },
    outLink () {
      if (window.Android) {
        window.Location.href = 'https://bankifsccode.com/'
      } else {
        window.open('https://bankifsccode.com/', '_blank')
      }
    },
    setAccount (rowNum) {
      switch (this.setupType) {
        case 'id':
          if (!this.personalInfo.fullName || !this.personalInfo.fullName.trim()) {
            Toast(this.$t('lang.account.withdrawSetup.promptFillName'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          let pattern = /\d{2}-\d{2}-\d{4}/
          if (!this.personalInfo.Birthday || !this.personalInfo.Birthday.trim() || !pattern.test(this.personalInfo.Birthday)) {
            Toast(this.$t('lang.account.withdrawSetup.promptFillBirthday'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          if (!this.personalInfo.cardNum) {
            Toast(this.$t('lang.account.withdrawSetup.promptFillCard'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          if (!this.AadhaarReg.test(this.personalInfo.cardNum)) {
            Toast(this.$t('lang.account.withdrawSetup.promptCardInvalid'))

            if (this.idSetup === 'img') {
              this.idSetup = 'info'
            }
            return
          }

          if (!this.documentList[0].fileServer) {
            Toast(this.$t('lang.account.withdrawSetup.promptUploadFrontCard'))

            if (this.idSetup === 'info') {
              this.idSetup = 'img'
            }
            return
          }

          if (!this.documentList[1].fileServer) {
            Toast(this.$t('lang.account.withdrawSetup.promptUploadBackCard'))

            if (this.idSetup === 'info') {
              this.idSetup = 'img'
            }
            return
          }

          if (!this.documentList[2].fileServer) {
            Toast(this.$t('lang.account.withdrawSetup.promptUploadPhoto'))

            if (this.idSetup === 'info') {
              this.idSetup = 'img'
            }
            return
          }

          const url = '/innovation/account/setuseridinfo'
          const data = {
            userId: this.userInfo.UserId,
            FullName: this.personalInfo.fullName.trim(),
            Birthday: this.personalInfo.Birthday,
            AadhaarCardNumber: this.personalInfo.cardNum
          }
          request('post', url, data).then(res => {
            Toast(res.Message)
            switch (res.Code) {
              case 0:
                if (this.idSetup === 'info') {
                  this.idSetup = 'img'
                }
                this.setUserVerifyInfo(res.UserVerifyInfo)
                break
              case 10:
                this.setUserVerifyInfo(res.UserVerifyInfo)
                break
              case -1:
                break
            }
          }).catch(err => {
            console.log(err)
            Toast(this.$t('lang.account.withdrawSetup.errorUpload'))
          })
          break
        case 'account':
          if (this.accountInfo[rowNum].AccountName && this.accountInfo[rowNum].AccountName.trim() && this.accountInfo[rowNum].AccountNumber && this.accountInfo[rowNum].BankCode) {
            if (!this.AccountNameReg.test(this.accountInfo[rowNum].AccountName.trim())) {
              Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccountName'))
              return
            }
            if (!this.AccountNumberReg.test(this.accountInfo[rowNum].AccountNumber)) {
              Toast(this.$t('lang.account.withdrawSetup.promptInvalidAccount'))
              return
            }
            if (!this.IFSCReg.test(this.accountInfo[rowNum].BankCode)) {
              Toast(this.$t('lang.account.withdrawSetup.promptInvalidCard'))
              return
            }
            const url = '/innovation/account/set/userbankaccount'
            const data = {
              UserId: this.userInfo.UserId,
              AccountName: this.accountInfo[rowNum].AccountName.trim(),
              AccountNumber: this.accountInfo[rowNum].AccountNumber,
              BankCode: this.accountInfo[rowNum].BankCode,
              Id: this.accountInfo[rowNum].Id
            }
            request('post', url, data).then(res => {
              Toast(res.Message)
              if (res.Code > 0) {
                this.fetchVerifyInfo()
              }
            }).catch(err => {
              console.log(err)
              Toast(this.$t('lang.account.withdrawSetup.errorUpload'))
            })
          } else if (!this.accountInfo.accountName || !this.accountInfo.accountName.trim()) {
            Toast(this.$t('lang.account.withdrawSetup.promptFillAccountName'))
          } else if (!this.accountInfo.accountNo) {
            Toast(this.$t('lang.account.withdrawSetup.promptFillAccountNumber'))
          } else if (!this.accountInfo.IFSC) {
            Toast(this.$t('lang.account.withdrawSetup.promptFillIFSC'))
          }
          break
      }
    },
    fetchVerifyInfo () {
      const url = '/innovation/account/getuserverifyinfo'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.setUserVerifyInfo(res.UserVerifyInfo)
        this.setUserBankList(res.BankAccountList)
        const filterList = res.BankAccountList.filter((e) => {
          return e.IsLastUsed === true
        })
        if (filterList.length > 0) {
          this.activeCardId = filterList[0].Id
        }
        if (this.activeCardId === -1 && this.$store.state.bankList && this.$store.state.bankList.length > 0) {
          this.activeCardId = this.$store.state.bankList[0].Id
        }
        this.chooseCard(this.activeCardId)
      }).catch(err => {
        console.log(err)
      })
    },
    copy () {
      this.$refs.link.select()
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    onValueChange (picker, value) {
      if (this.showPopup && value && value.length > 0 && value[0] !== undefined) {
        this.accountInfo.IFSC = value[0].code
      }
    }
  }
}
</script>

<style lang="less" scoped>
.withdrawSetupPage {
  height: 100%;
  width: 100%;

  .close {
    position: absolute;
    height: 4.05vw;
    width: 4.05vw;
    top: -9vw;
    left: 87vw;
  }

  .balanceTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 8.61vw;

    .title {
      color: #DEBC86;
      font-size: 6vw;
      font-weight: 700;
    }

    .tip {
      font-size: 3.88vw;
      color: #919191;
      margin-top: 0.5vw;
    }
  }

  .formBox {
    //margin-top: 5vw;
    padding: 5vw;

    .titleBox {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        color: #FFFFFF;
        font-size: 3.611vw;
        font-weight: 700;
      }

      .createAccount {
        color: #FFFFFF;
        font-size: 3.055vw;
        border-bottom: 1px solid;
        padding-bottom: 0.2vw;
      }
    }

    .accountList {
      display: flex;
      flex-direction: column;
      margin-top: 4vw;
      gap: 2vw;

      .nodata {
        color: #FFFFFF;
        font-size: 3.055vw;
        text-align: center;
        padding: 1vw;

        span {
          border-bottom: 1px solid;
          padding-bottom: 0.2vw;
        }
      }

      .listBox {
        display: flex;
        flex-direction: column;
        gap: 2vw;
        max-height: 32vw;
        overflow-y: auto;
      }

      .accountItemChecked {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .itemBox {
          width: 75.27vw;
          height: 12.22vw;
          border: 2px solid #F6D9AA;
          border-radius: 2.5vw;
          padding: 1.5vw 3.011vw;
          position: relative;

          .row1 {
            display: flex;
            align-items: center;
            padding-bottom: 1vw;

            .AccountIcon {
              width: 3.18vw;
              height: 2.5vw;
            }

            .AccountName {
              font-size: 3.33vw;
              color: #FFFFFF;
              font-weight: 700;
              margin-left: 1.86vw;
              display: flex;
              align-items: center;
              width: 50vw;
              white-space: nowrap;
              overflow: hidden;

              .BankMessage {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: red;
                padding-left: 2vw;
              }
            }
          }

          .row2 {
            .accountNumber {
              font-size: 3.055vw;
              color: #A7A7A7;
            }
          }
        }

        .edit {
          position: relative;
          width: 5.277vw;
          height: 12.21vw;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            height: auto;
          }
        }

        .checked {
          position: relative;
          width: 5.277vw;
          height: 12.21vw;
          display: flex;
          align-items: center;
          justify-content: center;

          .node {
            height: 2.777vw;
            width: 2.777vw;
            background-image: url("../../assets/images/account/checked.svg");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      .accountItem {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .edit {
          position: relative;
          width: 5.277vw;
          height: 12.21vw;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            height: auto;
          }
        }

        .itemBox {
          width: 75.27vw;
          height: 12.22vw;
          border: 2px solid rgb(115, 115, 115);
          border-radius: 2.5vw;
          padding: 1.5vw 3.011vw;
          position: relative;

          .row1 {
            display: flex;
            align-items: center;
            padding-bottom: 1vw;

            .AccountIcon {
              width: 3.18vw;
              height: 2.5vw;
            }

            .AccountName {
              font-size: 3.33vw;
              color: #FFFFFF;
              font-weight: 700;
              margin-left: 1.86vw;
              display: flex;
              align-items: center;
              width: 50vw;
              white-space: nowrap;
              overflow: hidden;

              .BankMessage {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: red;
                padding-left: 2vw;
              }
            }
          }

          .row2 {
            .accountNumber {
              font-size: 3.055vw;
              color: #A7A7A7;
            }
          }
        }

        .edit {
          position: relative;
          width: 5.277vw;
          height: 12.21vw;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 100%;
            height: auto;
          }
        }

        .checked {
          position: relative;
          width: 5.277vw;
          height: 12.21vw;
          display: flex;
          align-items: center;
          justify-content: center;

          .node {
            height: 2.777vw;
            width: 2.777vw;
            background-color: #D9D9D9;
            border-radius: 100vw;
          }
        }
      }

      .tip {
        width: 100%;
        //border: 1px solid red;
        text-align: center;
        font-size: 3.055vw;
        color: #CF2C01;
        padding: 3vw 0;
        border-bottom: 1px solid #3E3E3E;
      }

      .delayedBox {
        .head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 3.055vw;
          padding-top: 1vw;

          .tipText {
            color: #FFFFFF;
          }

          .deatil {;
            color: #979797;
            border-bottom: 1px solid #979797;
          }
        }

        .deepBox {
          width: 83.075vw;
          height: 18.847vw;
          background-color: #070707;
          border-radius: 1.388vw;
          margin-top: 3vw;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .line {
            border-top: 0.4vw dashed #DEBC86;
            width: 70.105vw;
          }

          .nodeBox {
            width: 100%;
            position: absolute;
            display: flex;
            justify-content: space-between;
            padding: 0 5vw;

            .node {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #000;
              font-size: 2.5vw;
              font-weight: 700;
            }

            .node:nth-child(1) {
              height: 1.388vw;
              width: 1.388vw;
              border-radius: 10vw;
              position: relative;
              top: 2.4vw;
              background: radial-gradient(circle at center, #FFF6D3 0%, #FFD485 100%);
            }

            .node:nth-child(2) {
              height: 6.11vw;
              width: 6.11vw;
              color: #000;
              background-color: #3FFF27;
              border-radius: 10vw;
            }

            .node:nth-child(3) {
              height: 6.11vw;
              width: 6.11vw;
              color: #000;
              background-color: #3FFF27;
              border-radius: 10vw;
            }
          }

          .textBox {
            width: 100%;
            position: absolute;
            top: 14vw;
            display: flex;
            justify-content: space-between;
            padding: 0 3.5vw;
            font-size: 2.5vw;
            color: #CFCFCF;
            font-weight: 700;

            .text {
              //flex: 1;
              text-align: center;
              position: relative;
              left: -1vw;
            }

            .text1 {
              width: 7vw;
              //border: 1px solid red;
            }

            .text2 {
              width: 20vw;
              //border: 1px solid red;
              text-align: center;
              position: relative;
              left: 4vw;
            }

            .text3 {
              width: 20vw;
              //border: 1px solid red;
              text-align: right;
            }

            //.text2{
            //  text-align: right;
            //  position: relative;
            //  left: -2.5vw;
            //}
            //.text:nth-child(3){
            //  text-align: right;
            //  position: relative;
            //  left: 2.5vw;
            //}
          }
        }
      }

      .submit {
        height: 11.68vw;
        color: #000000;
        background-color: #F6D9AA;
        font-size: 4.305vw;
        font-weight: 700;
        border-radius: 1.94vw;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 4vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawSetup/index.vue